import { IAddress, IAddressSubscription, IDeposit, ISpotRate, IWallet } from '@libs/interfaces';
import { createAction, props } from '@ngrx/store';
export const addSpots = createAction('[User Wallet] Add spots', props<{ spots: ISpotRate[] }>());
export const setWallet = createAction('[User Wallet] Set wallet balance address', props<{ wallet: IWallet }>());
export const setWallets = createAction('[User Wallet] Set wallets', props<{ wallets: IWallet[] }>());
export const updateBalance = createAction('[User Wallet] Update balance', props<{ balance: number }>());
export const toggleDisplayFiat = createAction('[User Wallet] Toggle display fiat');
export const setAddress = createAction(
  '[User Wallet] Set address',
  props<{ address: IAddress; subscription: IAddressSubscription }>(),
);

export const addOnRamperUrl = createAction('[User Wallet] Add onramper Url', props<{ onRamperUrl }>());
export const setMetamaskConnected = createAction('[User Wallet] Metamask connected', props<{ connected }>());
export const setMetamaskLocked = createAction('[User Wallet] Metamask Locked', props<{ locked }>());
export const setMetamaskAddress = createAction('[User Wallet] Metamask Address', props<{ address }>());
export const setMetamaskNetwork = createAction('[User Wallet] Metamask Network', props<{ wallet }>());
export const setMetamaskBalance = createAction('[User Wallet] Metamask Balance', props<{ balance }>());
export const setMetamaskAsProvider = createAction('[User Wallet] Metamask as provider', props<{ asProvider }>());
export const pendingWithdraw = createAction('[User Wallet] Pending Withdraw', props<{ withdraw }>());
export const pendingDeposits = createAction('[User Wallet] Pending deposits', props<{ pendingDeposits: IDeposit[] }>());
